import './arrays';

// Credit David Walsh (https://davidwalsh.name/javascript-debounce-function)

// Returns a function, that, as long as it continues to be invoked, will not
// be triggered. The function will be called after it stops being called for
// N milliseconds. If `immediate` is passed, trigger the function on the
// leading edge, instead of the trailing.

const debounce = (func, wait, immediate) => {
	var timeout;

	return function executedFunction() {
		var context = this;
		var args = arguments;

		var later = function () {
			timeout = null;
			if (!immediate) func.apply(context, args);
		};

		var callNow = immediate && !timeout;

		clearTimeout(timeout);

		timeout = setTimeout(later, wait);

		if (callNow) func.apply(context, args);
	};
};

const throttle = (callback, limit) => {
	var wait = false; // Initially, we're not waiting
	return function () {
		// We return a throttled function
		if (!wait) {
			// If we're not waiting
			callback.call(); // Execute users function
			wait = true; // Prevent future invocations
			setTimeout(function () {
				// After a period of time
				wait = false; // And allow future invocations
			}, limit);
		}
	};
};

const cartHasProduct = (cart, id) => {
	return cartHasItem(cart, 'product_id', id);
};

const cartHasVariant = (cart, id) => {
	return cartHasItem(cart, 'variant_id', id);
};

const cartHasItem = (cart, type, id) => {
	let items = cart.items;
	for (let i = 0; i < items.length; ++i) {
		if (items[i][type] == id) return true;
	}
	return false;
};

// https://masteringjs.io/tutorials/fundamentals/compare-arrays
const arraysAreEqual = (a, b) => {
	return (
		Array.isArray(a) &&
		Array.isArray(b) &&
		a.length === b.length &&
		a.every((val, index) => val === b[index])
	);
};

export { debounce, throttle, cartHasItem, cartHasProduct, cartHasVariant, arraysAreEqual };
